
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ProfessionalModel } from '../../models/configuration/professional.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { ProfessionalEntity } from '../../../data/repositories/configuration/entities/professional.entity';
    export class GetProfessionalUseCase implements UseCase<void, ProfessionalModel> {
        constructor(private config: ConfigurationRepository) { }
        execute(): Observable<ProfessionalEntity> {
    return this.config.getProfessional();
    }
}    